import React, { useState, useRef, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { useAuth, getAuthMode } from '@/contexts/AuthWrapper';
import styles from '@/styles/pages/HomePage.module.css';
import Footer from '@/components/Footer';
import { AuthTest } from '@/components/dev/AuthTest';

const newsData = [
  {
    date: '27.02.25',
    title: 'AI Breakthrough: Big Tiger Gemma 27B v1 Unveiled',
    description:
      'Big Tiger Gemma 27B v1 is a Decensored Gemma 27B model with no refusals, except for some rare instances from the 9B model. It does not appear to have any brain damage. The model is available from various sources, including Hugging Face, and comes in different variations such as GGUF, iMatrix, and EXL2.',
  },
  {
    date: '27.02.25',
    title: 'AI Breakthrough: Big Tiger Gemma 27B v1 Unveiled',
    description:
      'Big Tiger Gemma 27B v1 is a Decensored Gemma 27B model with no refusals, except for some rare instances from the 9B model. It does not appear to have any brain damage. The model is available from various sources, including Hugging Face, and comes in different variations such as GGUF, iMatrix, and EXL2.',
  },
  {
    date: '27.02.25',
    title: 'AI Breakthrough: Big Tiger Gemma 27B v1 Unveiled',
    description:
      'Big Tiger Gemma 27B v1 is a Decensored Gemma 27B model with no refusals, except for some rare instances from the 9B model. It does not appear to have any brain damage. The model is available from various sources, including Hugging Face, and comes in different variations such as GGUF, iMatrix, and EXL2.',
  },
];

const HomePage: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const username = user?.name || 'Username';
  const [expanded, setExpanded] = useState<number | null>(null);

  // Dropdown logic
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    navigate('/text-chat', { replace: true });
  }, [navigate]);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    }
    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  return (
    <>
      <Helmet>
        <title>Swarmind - Web3 inference managment system</title>
        <meta name="description" content="Swarmind - Web3 inference managment system" />
        <meta property="og:title" content="Swarmind" />
        <meta property="og:description" content="Swarmind - Web3 inference managment system" />
        <meta property="og:url" content="https://swarmind.ai/" />
        <meta property="og:type" content="website" />
        <meta property="twitter:title" content="Swarmind" />
        <meta property="twitter:description" content="Swarmind - Web3 inference managment system" />
        <meta property="twitter:url" content="https://swarmind.ai/" />
      </Helmet>
      <div className={styles.frameParent}>
      {/* Header (top right avatar) - hidden on desktop, can be used for mobile */}
      <div className={styles.avatarParent} style={{ display: 'none' }}>
        <div className={styles.avatar}>
          <div className={styles.avatar1}>
            <div className={styles.base} />
            <img className={styles.smIcon} alt="" src="/icons/sm_icon.svg" />
          </div>
        </div>
        <b className={styles.text}>{username}</b>
        <img
          className={styles.mdRightIcon}
          alt=""
          src="/icons/md_right_icon.svg"
        />
      </div>

      {/* Top nav item (for mobile) - hidden on desktop */}
      <div className={styles.topNavItem} style={{ display: 'none' }}>
        <div className={styles.avatar2}>
          <div className={styles.at}>{username[0]}</div>
        </div>
        <div className={styles.textWrap}>
          <div className={styles.text1}>{username}</div>
        </div>
        <img className={styles.rightIcon} alt="" src="/icons/right_icon.svg" />
      </div>

      {/* Main content */}
      <div className={styles.textParent}>
        <div className={styles.text2}>Welcome, {username}!</div>
        
        {/* Development Auth Mode Indicator */}
        {process.env.NODE_ENV === 'development' && (
          <div style={{
            padding: '8px 12px',
            backgroundColor: getAuthMode().isAuthDisabled ? '#fef3c7' : '#d1fae5',
            color: getAuthMode().isAuthDisabled ? '#92400e' : '#065f46',
            borderRadius: '6px',
            fontSize: '12px',
            marginBottom: '16px',
            border: `1px solid ${getAuthMode().isAuthDisabled ? '#fbbf24' : '#10b981'}`,
          }}>
            🔧 Auth Mode: {getAuthMode().mode.toUpperCase()} 
            {getAuthMode().isAuthDisabled && ' (Authentication Disabled)'}
          </div>
        )}
        
        {/* Authentication Test Component - Remove this in production */}
        <AuthTest />
        {newsData.map((news, idx) => (
          <div className={styles.cardNews} key={idx}>
            <div className={styles.autoLayoutVertical}>
              <div className={styles.sizesmTypetertiary}>
                <img
                  className={styles.iconCalender}
                  alt=""
                  src="/icons/calender.svg"
                />
                <div className={styles.autoLayoutHorizontal}>
                  <div className={styles.text3}>{news.date}</div>
                </div>
              </div>
              <div className={styles.aiBreakthroughBig}>{news.title}</div>
            </div>
            <div className={styles.text4}>
              <div
                className={styles.bigTigerGemma}
                style={{
                  WebkitLineClamp: expanded === idx ? 'unset' : 3,
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {news.description}
              </div>
              <div
                className={styles.sizesmTypequaternaryAc}
                style={{ color: '#5E64FF', cursor: 'pointer' }}
                onClick={() => setExpanded(expanded === idx ? null : idx)}
              >
                <div className={styles.autoLayoutHorizontal1}>
                  <div className={styles.text3}>
                    {expanded === idx ? 'Collapse text' : 'Expand text'}
                  </div>
                </div>
                <img
                  className={styles.iconCalender}
                  alt=""
                  src="/icons/dropdown.svg"
                  style={{
                    transform:
                      expanded === idx ? 'rotate(0deg)' : 'rotate(180deg)',
                    transition: 'transform 0.2s',
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </div>
    </>
  );
};

export default HomePage;
